import React, { createContext, useContext, useState } from 'react';

export const CURRENCIES = [
  { code: 'USD', symbol: '$',  locale: 'en-US',  name: 'US Dollar',        flag: '🇺🇸', country: 'United States' },
  { code: 'EUR', symbol: '€',  locale: 'de-DE',  name: 'Euro',             flag: '🇪🇺', country: 'European Union' },
  { code: 'GBP', symbol: '£',  locale: 'en-GB',  name: 'British Pound',    flag: '🇬🇧', country: 'United Kingdom' },
  { code: 'INR', symbol: '₹',  locale: 'en-IN',  name: 'Indian Rupee',     flag: '🇮🇳', country: 'India' },
  { code: 'PKR', symbol: '₨',  locale: 'en-PK',  name: 'Pakistani Rupee',  flag: '🇵🇰', country: 'Pakistan' },
  { code: 'AED', symbol: 'د.إ',locale: 'ar-AE',  name: 'UAE Dirham',       flag: '🇦🇪', country: 'UAE' },
  { code: 'SAR', symbol: '﷼',  locale: 'ar-SA',  name: 'Saudi Riyal',      flag: '🇸🇦', country: 'Saudi Arabia' },
  { code: 'JPY', symbol: '¥',  locale: 'ja-JP',  name: 'Japanese Yen',     flag: '🇯🇵', country: 'Japan' },
  { code: 'CNY', symbol: '¥',  locale: 'zh-CN',  name: 'Chinese Yuan',     flag: '🇨🇳', country: 'China' },
  { code: 'CAD', symbol: 'CA$',locale: 'en-CA',  name: 'Canadian Dollar',  flag: '🇨🇦', country: 'Canada' },
  { code: 'AUD', symbol: 'A$', locale: 'en-AU',  name: 'Australian Dollar',flag: '🇦🇺', country: 'Australia' },
  { code: 'CHF', symbol: 'Fr', locale: 'de-CH',  name: 'Swiss Franc',      flag: '🇨🇭', country: 'Switzerland' },
  { code: 'KWD', symbol: 'KD', locale: 'ar-KW',  name: 'Kuwaiti Dinar',   flag: '🇰🇼', country: 'Kuwait' },
  { code: 'QAR', symbol: 'QR', locale: 'ar-QA',  name: 'Qatari Riyal',    flag: '🇶🇦', country: 'Qatar' },
  { code: 'OMR', symbol: 'OMR',locale: 'ar-OM',  name: 'Omani Rial',      flag: '🇴🇲', country: 'Oman' },
  { code: 'BHD', symbol: 'BD', locale: 'ar-BH',  name: 'Bahraini Dinar',  flag: '🇧🇭', country: 'Bahrain' },
  { code: 'MYR', symbol: 'RM', locale: 'ms-MY',  name: 'Malaysian Ringgit',flag: '🇲🇾', country: 'Malaysia' },
  { code: 'SGD', symbol: 'S$', locale: 'en-SG',  name: 'Singapore Dollar', flag: '🇸🇬', country: 'Singapore' },
  { code: 'BDT', symbol: '৳',  locale: 'bn-BD',  name: 'Bangladeshi Taka', flag: '🇧🇩', country: 'Bangladesh' },
  { code: 'NPR', symbol: 'Rs', locale: 'ne-NP',  name: 'Nepalese Rupee',   flag: '🇳🇵', country: 'Nepal' },
  { code: 'LKR', symbol: 'Rs', locale: 'si-LK',  name: 'Sri Lankan Rupee', flag: '🇱🇰', country: 'Sri Lanka' },
  { code: 'AFN', symbol: '؋',  locale: 'ps-AF',  name: 'Afghan Afghani',   flag: '🇦🇫', country: 'Afghanistan' },
  { code: 'TRY', symbol: '₺',  locale: 'tr-TR',  name: 'Turkish Lira',     flag: '🇹🇷', country: 'Turkey' },
  { code: 'IRR', symbol: '﷼',  locale: 'fa-IR',  name: 'Iranian Rial',     flag: '🇮🇷', country: 'Iran' },
  { code: 'IQD', symbol: 'ع.د',locale: 'ar-IQ',  name: 'Iraqi Dinar',      flag: '🇮🇶', country: 'Iraq' },
  { code: 'EGP', symbol: 'E£', locale: 'ar-EG',  name: 'Egyptian Pound',   flag: '🇪🇬', country: 'Egypt' },
  { code: 'NGN', symbol: '₦',  locale: 'en-NG',  name: 'Nigerian Naira',   flag: '🇳🇬', country: 'Nigeria' },
  { code: 'ZAR', symbol: 'R',  locale: 'en-ZA',  name: 'South African Rand',flag:'🇿🇦', country: 'South Africa' },
  { code: 'KES', symbol: 'KSh',locale: 'en-KE',  name: 'Kenyan Shilling',  flag: '🇰🇪', country: 'Kenya' },
  { code: 'BRL', symbol: 'R$', locale: 'pt-BR',  name: 'Brazilian Real',   flag: '🇧🇷', country: 'Brazil' },
  { code: 'MXN', symbol: 'MX$',locale: 'es-MX',  name: 'Mexican Peso',     flag: '🇲🇽', country: 'Mexico' },
  { code: 'RUB', symbol: '₽',  locale: 'ru-RU',  name: 'Russian Ruble',    flag: '🇷🇺', country: 'Russia' },
  { code: 'KRW', symbol: '₩',  locale: 'ko-KR',  name: 'South Korean Won', flag: '🇰🇷', country: 'South Korea' },
  { code: 'IDR', symbol: 'Rp', locale: 'id-ID',  name: 'Indonesian Rupiah',flag: '🇮🇩', country: 'Indonesia' },
  { code: 'THB', symbol: '฿',  locale: 'th-TH',  name: 'Thai Baht',        flag: '🇹🇭', country: 'Thailand' },
  { code: 'PHP', symbol: '₱',  locale: 'en-PH',  name: 'Philippine Peso',  flag: '🇵🇭', country: 'Philippines' },
  { code: 'VND', symbol: '₫',  locale: 'vi-VN',  name: 'Vietnamese Dong',  flag: '🇻🇳', country: 'Vietnam' },
  { code: 'SEK', symbol: 'kr', locale: 'sv-SE',  name: 'Swedish Krona',    flag: '🇸🇪', country: 'Sweden' },
  { code: 'NOK', symbol: 'kr', locale: 'nb-NO',  name: 'Norwegian Krone',  flag: '🇳🇴', country: 'Norway' },
  { code: 'DKK', symbol: 'kr', locale: 'da-DK',  name: 'Danish Krone',     flag: '🇩🇰', country: 'Denmark' },
  { code: 'PLN', symbol: 'zł', locale: 'pl-PL',  name: 'Polish Zloty',     flag: '🇵🇱', country: 'Poland' },
];

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    try {
      const saved = localStorage.getItem('ems_currency');
      return saved ? JSON.parse(saved) : CURRENCIES[0];
    } catch {
      return CURRENCIES[0];
    }
  });

  const changeCurrency = (c) => {
    setCurrency(c);
    localStorage.setItem('ems_currency', JSON.stringify(c));
  };

  const fmt = (v) => {
    try {
      return new Intl.NumberFormat(currency.locale, {
        style: 'currency',
        currency: currency.code,
        maximumFractionDigits: 2,
      }).format(v || 0);
    } catch {
      return `${currency.symbol}${Number(v || 0).toFixed(2)}`;
    }
  };

  return (
    <CurrencyContext.Provider value={{ currency, changeCurrency, fmt }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
